import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row mb-4" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = ["value", "onBlur", "onFocus"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, " Укажите начало ", -1)
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = ["value", "onBlur", "onFocus"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, " Укажите конец ", -1)
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = { class: "col-12" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-12 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_ui = _resolveComponent("loader-ui")!
  const _component_select_ui = _resolveComponent("select-ui")!
  const _component_form_group_ui = _resolveComponent("form-group-ui")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_input_ui = _resolveComponent("input-ui")!
  const _component_button_ui = _resolveComponent("button-ui")!
  const _component_modal_ui = _resolveComponent("modal-ui")!

  return (_openBlock(), _createBlock(_component_modal_ui, {
    id: _ctx.id,
    size: "modal-xl",
    title: _ctx.state.title
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "loader",
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)), ["prevent"]))
      }, [
        _createVNode(_component_loader_ui, {
          "is-show": _ctx.state.loader
        }, null, 8, ["is-show"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Выберите сотрудника",
              label: "Сотрудник",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_select_ui, {
                  "is-invalid": _ctx.state.visibleErrors && _ctx.isEmployeeIdError,
                  options: _ctx.employees,
                  placeholder: "Сотрудник",
                  searchable: true,
                  values: [_ctx.state.employeeId],
                  onOnSelected: _ctx.onEmployeeSelect
                }, null, 8, ["is-invalid", "options", "values", "onOnSelected"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Выберите начало",
              label: "Начало",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_date_picker, {
                  modelValue: _ctx.state.startsAt,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.startsAt) = $event)),
                  class: "inline-block h-full",
                  is24hr: true,
                  mode: "date"
                }, {
                  default: _withCtx(({ inputValue, togglePopover }) => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("input", {
                        class: _normalizeClass(["form-control", { 'is-invalid': _ctx.isStartsAtError && _ctx.state.visibleErrors, 'bg-white': true }]),
                        as: "",
                        readonly: "",
                        timezone: 'Asia/Almaty',
                        value: inputValue,
                        onBlur: ($event: any) => (togglePopover()),
                        onFocus: ($event: any) => (togglePopover())
                      }, null, 42, _hoisted_5),
                      _hoisted_6
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Выберите конец",
              label: "Конец",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_date_picker, {
                  modelValue: _ctx.state.endsAt,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.endsAt) = $event)),
                  class: "inline-block h-full",
                  is24hr: true,
                  mode: "date"
                }, {
                  default: _withCtx(({ inputValue, togglePopover }) => [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("input", {
                        class: _normalizeClass(["form-control", { 'is-invalid': _ctx.isEndsAtError && _ctx.state.visibleErrors, 'bg-white': true }]),
                        as: "",
                        readonly: "",
                        timezone: 'Asia/Almaty',
                        value: inputValue,
                        onBlur: ($event: any) => (togglePopover()),
                        onFocus: ($event: any) => (togglePopover())
                      }, null, 42, _hoisted_8),
                      _hoisted_9
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Укажите расценку",
              label: "Расценка",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_input_ui, {
                  modelValue: _ctx.state.unitPrice,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.unitPrice) = $event)),
                  "is-invalid": _ctx.state.visibleErrors && _ctx.isUnitPriceError,
                  mask: { mask: 'Z*', tokens: { 'Z': { pattern: /[0-9]/ } } },
                  placeholder: "Расценка"
                }, null, 8, ["modelValue", "is-invalid"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Примечание",
              label: "Примечание"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_input_ui, {
                  modelValue: _ctx.state.comment,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.comment) = $event)),
                  placeholder: "Примечание"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_button_ui, { "button-class": "btn-primary" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.state.btn), 1)
              ]),
              _: 1
            })
          ])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["id", "title"]))
}